export const baseItemClassName =
  'py-2 px-2 rounded transition-none outline-none hover:bg-gray-50 focus-within:bg-gray-50 flex flex-row items-center w-full justify-between text-gray-900 text-sm'
